import React from 'react';
import { Section } from './ui/Section';
export function VisualDesire() {
  const photos = [{
    label: 'Pan',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e5fc5124-93ef-444b-a413-4c5df04d17c9.jpg'
  }, {
    label: 'Pizza y masas',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/2dc28840-75d6-4cc2-bdc0-2ed41966abc2.jpg'
  }, {
    label: 'Pasta',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7ad5ad3d-7c30-45b6-974b-34f44ab275b1.jpg'
  }, {
    label: 'Dulces',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e0ee02ce-49ea-49ff-bbc5-eb9cd79067b8.jpg'
  }];
  return <Section variant="alt" data-id="element-214" data-mp="1yoa7nj9ti66x">
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-215" data-mp="1tq0bp6g9r1k9">
        Parece lo de siempre. Esa es la idea.
      </h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-4xl mx-auto mb-8" data-id="element-216" data-mp="27qb2yalhqi5y">
        {photos.map((photo, i) => <div key={i} className="relative rounded-2xl overflow-hidden shadow-card aspect-square" data-id="element-217" data-mp="22olu91lqqgl1" data-mpi={i}>
            <img src={photo.img} alt={photo.label} className="w-full h-full object-cover" loading="lazy" data-id="element-218" data-mp="2ihkk0gqo7fj4" />
            <div className="absolute bottom-0 left-0 right-0 bg-brand-title/70 text-white text-center text-xs md:text-sm font-heading font-bold uppercase tracking-wide py-2" data-id="element-219" data-mp="2ngdzuftfjimg">
              {photo.label}
            </div>
          </div>)}
      </div>

      <p className="text-center text-brand-text font-body max-w-xl mx-auto leading-relaxed text-sm md:text-base" data-id="element-220" data-mp="31dasmmt3za5z">
        No buscamos que aprendas a resignarte a una versión "sin". Aprendes a
        reconstruir lo que hace que cada preparación funcione.
      </p>
    </Section>;
}